'use strict';

import angular from 'angular';
import UpdatedController from './updated.controller';

export default angular.module('updateServerApp.firmwares.updated', [])
  .controller('FirmwaresUpdatedController', UpdatedController)
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/updated/index.js